import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';

export const ModalContainer = styled.View`
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: ${RFValue(20)}px;
  overflow: hidden;
`;

export const ModalBackground = styled.ImageBackground`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: ${RFValue(20)}px;
`;

export const ModalContent = styled.View`
  background-color: transparent;
  border-radius: ${RFValue(20)}px;
  width: 100%;
  padding:0 16px;
  padding-bottom: 16px;

  position: relative;
`;

export const CloseModalIconButton = styled.TouchableOpacity`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: ${RFValue(15)}px;
  width: ${RFValue(30)}px;
  height: ${RFValue(30)}px;
  justify-content: center;
  align-items: center;
`;

export const CloseIcon = styled(Feather)`
  font-size: ${RFValue(16)}px;
  color: #ffffff;
`;

export const ModalBody = styled.View`
  padding: 0 ;
  align-items: center;
`;

export const ModalTitle = styled.Text`
  text-align: center;
  font-size: ${RFValue(24)}px;
  color: #ffd700;
  font-family: ${({theme}) => theme.fonts.bold};
  margin-bottom: ${RFValue(8)}px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
`;

export const ModalText = styled.Text`
  text-align: center;
  font-size: ${RFValue(16)}px;
  color: #ffffff;
  font-family: ${({theme}) => theme.fonts.regular};
  margin-bottom: ${RFValue(16)}px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
`;

export const ModalFooter = styled.View`

`;

export const PrizeImage = styled(FastImage as any)`
  width: ${RFValue(200)}px;
  height: ${RFValue(200)}px;
  margin: ${RFValue(-36)}px 0;

`;

// Coupon Styles
export const CouponContainer = styled.View`
  margin-bottom: ${RFValue(20)}px;
  align-items: center;
`;

export const CouponContent = styled.View`
  flex-direction: row;
  background-color: #2a2a2a;
  border-radius: ${RFValue(12)}px;
  overflow: hidden;
  position: relative;
  min-height: ${RFValue(80)}px;

  border: 2px solid #ffd700;

  /* Semicircular notches on left and right sides */
  &::before {
    content: '';
    position: absolute;
    left: -${RFValue(8)}px;
    top: 50%;
    width: ${RFValue(16)}px;
    height: ${RFValue(16)}px;
    background-color: transparent;
    border-radius: ${RFValue(8)}px;
    transform: translateY(-50%);
  }

  &::after {
    content: '';
    position: absolute;
    right: -${RFValue(8)}px;
    top: 50%;
    width: ${RFValue(16)}px;
    height: ${RFValue(16)}px;
    background-color: transparent;
    border-radius: ${RFValue(8)}px;
    transform: translateY(-50%);
  }
`;

export const CouponLeftSide = styled.View`
  flex: 1;
  padding:${RFValue(12)}px 0;
  justify-content: center;
`;

export const CouponRightSide = styled.Pressable`

  padding: ${RFValue(12)}px ${RFValue(8)}px;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
`;

export const CouponDiscount = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(20)}px;
  color: #ffffff;
  text-align: center;

`;

export const CouponMaxValue = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  font-size: ${RFValue(12)}px;
  color: #ffffff;
  text-align: center;
  margin-bottom: ${RFValue(4)}px;
`;

export const CouponDescription = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: #cccccc;
  text-align: center;
`;

export const CouponBrand = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
  color: #00ff88;
  text-align: center;
`;

export const CouponExpiry = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(9)}px;
  color: #999999;
  text-align: center;
`;
